import { render, staticRenderFns } from "./ServiceRecordsTable.vue?vue&type=template&id=2081fa21&"
import script from "./ServiceRecordsTable.vue?vue&type=script&lang=js&"
export * from "./ServiceRecordsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports